/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Fragment } from "react";
import { AuditEventSubType, AuditLog, ListAuditLogsRequest } from "../../http/protocol";
import { ListView, ListViewProps, ListViewState } from "../ListView";
import { Form, FormListener } from "../form/Form";
import { ActionType } from "../list/list/DataTable";
import { EntityDataTable } from "../list/list/EntityDataTable";
import { FormGroup } from "../form/FormGroup";
import { FormInput } from "../form/FormInput";
import { ListUtils } from "../list/list/ListUtils";
import { PagerModel } from "../list/list/PagerModel";
import { getContainer } from "../../ioc/IOCSetup";
import { withRouter } from "react-router";
import { AuditLogService } from "../../services/AuditLogService";
import { ColumnType } from "../list/list/ColumnType";
import { SelectInput } from "../form/SelectInput";



interface State extends ListViewState<ListAuditLogsRequest> {
    listRequest?: ListAuditLogsRequest,
    form?: ListAuditLogsRequest,
    validationMap?: any;
    operatorError?: boolean;
    lookupExpanded?: boolean;
}


export class BonusUpdateListView extends ListView<State, ListAuditLogsRequest> implements FormListener<ListAuditLogsRequest> {


    auditLogService: AuditLogService;

    columns = [
        { property: "id", name: "ID", orderBy: "id" },
        { property: "timestamp", name: "Time", orderBy: "timestamp", type: ColumnType.DATE },
        { property: "actorId", name: "Actor ID", orderBy: "actorId"},
        { property: "actorEmail", name: "Actor Email" },
        { property: "actorIp", name: "Actor IP" },
        { property: "targetId", name: "Target Id", orderBy: "targetId"},
        { property: "eventName", name: "Event Type" },
        { property: "path", name: "Path" },

        { property: "request", name: "Bonus ID",
        renderer: (property: string, name: string, item: any) => {
            try{let parse = JSON.parse(item["request"]);
            return <span>{parse["id"]}</span>}
            catch(e){
                return <span>{"ERROR"}</span>
            }
        }},

        { property: "request", name: "Bonus amount",
        renderer: (property: string, name: string, item: any) => {
            try{
                let parse = JSON.parse(item["request"]);
                if(parse["totalBonusAmount"]===null){
                    return "";
                }else{
                    return <span>{parse["totalBonusAmount"]}</span>
                }
            }
            catch(e){
                return <span>{"ERROR"}</span>
            }
        }},

        { property: "request", name: "Bonus Config ID",
        renderer: (property: string, name: string, item: any) => {
            try{
                let parse = JSON.parse(item["request"]);
                if (!parse.hasOwnProperty("bonusConfig") || parse["bonusConfig"]["id"]===null){
                    return "";
                }
                else{
                    return <span>{parse["bonusConfig"]["id"]}</span>
                }
            }
            catch(e){
                return <span>{"ERROR"}</span>
            }
        }},

        { property: "request", name: "Name",
        renderer: (property: string, name: string, item: any) => {
            try{
                let parse = JSON.parse(item["request"]);
                if(!parse.hasOwnProperty("bonusConfig") ||parse["bonusConfig"]["name"]===null){
                    return "";
                }else{
                    return <span>{parse["bonusConfig"]["name"]}</span>
                }
            }
            catch(e){
                return <span>{"ERROR"}</span>
            }
        }},
    ];

    actions = [
        {
            id: "view",
            name: "Detail",
            className: "btn btn-primary",
            iconClassName: "fa fa-eye",
            type: ActionType.LINK,
            getLink: (item: AuditLog) => "/audit-log/" + item.id
        }
    ];

    constructor(props: ListViewProps) {
        super(props, "/audit-logs-bonus-update");
        let eventNames = [AuditEventSubType.BONUS_UPDATE,AuditEventSubType.BONUS_MONETARY_CONFIG_UPDATE,AuditEventSubType.BONUS_TRIGGER_UPDATE,AuditEventSubType.BONUS_CONTRIBUTION_UPDATE,AuditEventSubType.BONUS_CONFIG_UPDATE,AuditEventSubType.BONUS_OFFER_UPDATE];
        let listRequest : ListAuditLogsRequest = { limit: 50, ascending: false, orderBy: "id" , eventNames: eventNames};
        this.state = { ...this.state, validationMap: {}, form: { ...listRequest }, listRequest: listRequest };
        this.auditLogService = getContainer().getAuditLogService();
    }

    isJsonString(str:string) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    formDidUpdate(formModel: ListAuditLogsRequest, validationMap: any): void {
        this.setState({ form: formModel, validationMap: validationMap });
    }

    onSubmitError(): void {
        console.log("submit error!")
    }

    onSubmit(): void {
        let eventNames = [AuditEventSubType.BONUS_UPDATE,AuditEventSubType.BONUS_MONETARY_CONFIG_UPDATE,AuditEventSubType.BONUS_TRIGGER_UPDATE,AuditEventSubType.BONUS_CONTRIBUTION_UPDATE,AuditEventSubType.BONUS_CONFIG_UPDATE,AuditEventSubType.BONUS_OFFER_UPDATE];
        let listRequest: ListAuditLogsRequest = Object.assign({}, this.state.form);
        if(eventNames.includes(listRequest.eventName!)){
            listRequest.eventNames= [listRequest.eventName!];
        }else{
            listRequest.eventNames = eventNames;
        }
        this.setState({listRequest:listRequest});
    }

    filterEmpty(o: any): any {
        if (o == null || o === undefined || o === "") {
            return undefined;
        } else {
            return o;
        }
    }


    pagerChanged(pager: PagerModel) {
        if (!this.state.listRequest) {
            return;
        }
        let listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
        this.setState({ listRequest: listRequest });
    }

    onAction(item: AuditLog, action: string): undefined | Promise<any> {
        return;
    }

    getTitle() {
        return "Audit Logs Bonus Update";
    }


    getSearchByUserId() {
        return (
            <div className="row">
                <div className="col-lg-6">
                    <div className="card-box">
                        <Form formListener={this} modelObject={this.state.form}
                            validationMap={this.state.validationMap}>
                            <FormGroup className="form-group">
                                <label className="col-lg-2 control-label">Id</label>
                                <div className="col-lg-10">
                                    <FormInput className="form-control" model="id" type={"number"} />
                                </div>
                            </FormGroup>
                            <div className="form-group">
                                <div className="col-lg-offset-2 col-lg-10">
                                    <input className="btn btn-primary" value="Search" type={"submit"} />
                                </div>
                            </div>

                        </Form>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card-box">
                        <Form formListener={this} modelObject={this.state.form}
                            validationMap={this.state.validationMap}>
                            <FormGroup className="form-group">
                                <label className="col-lg-2 control-label">Actor Id</label>
                                <div className="col-lg-10">
                                    <FormInput className="form-control" model="actorId" type={"number"} />
                                </div>
                            </FormGroup>
                            <div className="form-group">
                                <div className="col-lg-offset-2 col-lg-10">
                                    <input className="btn btn-primary" value="Search" type={"submit"} />
                                </div>
                            </div>

                        </Form>
                    </div>
                </div>
            </div>
        );
    }


    getSearchByFilter() {
        return (
            <div className="card-box expandable-box" style={!this.state.lookupExpanded ? { cursor: "pointer" } : { cursor: "default" }} onClick={() => !this.state.lookupExpanded ? this.setState({ lookupExpanded: true }) : null}>
                {this.state.lookupExpanded && (
                    <a className="expand-button float-right"  onClick={() => this.setState({ lookupExpanded: false })}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    <a className="expand-button float-right"  onClick={() => this.setState({ lookupExpanded: true })}><i className="mdi mdi-plus"></i></a>
                )}
                <h4 className="header-title mb-3" onClick={() => this.setState({ lookupExpanded: !this.state.lookupExpanded })}>Advanced Search</h4>
                <br/>
                {this.state.lookupExpanded && (
                    <div>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label className="col-lg-3 control-label">Actor Email</label>
                                        <div className="col-lg-10">
                                            <FormInput className="form-control" model="actorEmail" type={"text"} />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label className="col-lg-2 control-label">Event Type</label>
                                        <div className="col-lg-10">
                                            <SelectInput size={1} className="form-control" model="eventName" optional={true}
                                                values={[AuditEventSubType.BONUS_UPDATE, AuditEventSubType.BONUS_MONETARY_CONFIG_UPDATE,
                                                AuditEventSubType.BONUS_TRIGGER_UPDATE, AuditEventSubType.BONUS_CONTRIBUTION_UPDATE,
                                                AuditEventSubType.BONUS_CONFIG_UPDATE, AuditEventSubType.BONUS_OFFER_UPDATE]} multiple={false} />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label className="col-lg-2 control-label">Target ID</label>
                                        <div className="col-lg-10">
                                            <FormInput className="form-control" model="targetId" type={"number"} />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label className="col-lg-2 control-label">Start Date</label>
                                        <div className="col-lg-10">
                                            <FormInput className="form-control" model="startDate" type={"date"} />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label className="col-lg-2 control-label">End Date</label>
                                        <div className="col-lg-10">
                                            <FormInput className="form-control" model="endDate" type={"date"} />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <div className="col-lg-offset-2 col-lg-10">
                                            <input className="btn btn-primary" value="Search" type={"submit"} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        );
    }

    renderContent() {
        if (!this.state.listRequest) {
            return <span></span>
        }

        return (
            <Fragment>
                {this.getSearchByUserId()}
                {this.getSearchByFilter()}


                <EntityDataTable
                    service={this.auditLogService}
                    onPagerChange={this.pagerChanged && this.pagerChanged.bind(this)}
                    columns={this.columns}
                    listRequest={this.state.listRequest}
                    onAction={this.onAction && this.onAction.bind(this)}
                    actions={this.actions}
                />
            </Fragment>
        );
    }

}

export default withRouter(BonusUpdateListView)